import React , { useState , useEffect } from 'react';
import { Grid, CardContent, Typography } from "@mui/material";
import colors from 'Assets/sass/core/vars.scss';
import { Button } from 'Components/uiControls';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import GlobalAlert from 'Components/GlobalAlert';

import './style.scss';

import {
  deleteGadgetDashboardPanel
} from 'Redux/actions';

//Views
import Gadgets from '../gadGets';


const UserGadget = (props) => {

  const { expandGadget, item, createEdit, editMode, deleteGadget } = props;
  const dispatch = useDispatch();
  const { messages } = useIntl();
  const [update, setUpdate] = useState(0)
  // to validate if the filter change widget is usable when the widget stores data and needs to be cleared upon filter change
  const [ changesFilters , setChangesFilters ] = useState(false)
  const [openConfirmationDelete, setOpenConfirmationDelete] = useState({});

  useEffect(() => {
    let timeSecond = item.refreshSeconds * 1000;
    const interval = setInterval(() => {
      setUpdate(Date.now());
    }, timeSecond);
    return () => clearInterval(interval);
  }, []);

  item.additionalName = "";
  let values;
  if (item.type === "RecentAlerts") {
    values = JSON.parse(item.settings);
  }

  return (
    <div className="dashboard_gadget" >
      <Grid
        sx={{
          backgroundColor: colors['color-primary'],
          paddingX: 2,
          paddingY: '4px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >

        <Grid container>
          <Grid item>
            <Typography style={{ fontWeight: 'bold', color: 'white', textAlign: 'left' }}>
              {item.name} {values?.timeFrame?.option?.label?`(${messages['dashboardPanel_recent_alerts_time_frame_custom']})`:''}
            </Typography>
          </Grid>
        </Grid>

        <Grid sx={{
          display: 'flex',
          justifyContent: 'space-end',
          alignItems: 'center',
          gap: 1,
        }} >

          {!editMode &&
            <>
              <Button
                type="icon"
                icon="refresh"
                style={{ color: 'white' }}
                className="header-icon"
                aria-label={messages['table_refresh']}
                tooltip={messages['table_refresh']}
                onClick={() => {
                  setUpdate(Date.now());
                  setChangesFilters(true);
                }}
              />
              <Button
                type="icon"
                icon="aspect_ratio"
                style={{ color: 'white' }}
                className="header-icon"
                aria-label={messages['dashboardPanel_expand_gadget']}
                tooltip={messages['dashboardPanel_expand_gadget']}
                onClick={() => {
                  expandGadget(item);
                }}
              />
            </>
          }

          {editMode &&
            <>
              <Button
                type="icon"
                icon="edit"
                style={{ color: 'white' }}
                className="header-icon"
                aria-label={messages['dashboardPanel_edit_gadget']}
                tooltip={messages['dashboardPanel_edit_gadget']}
                onClick={() => {
                  createEdit(item);
                  setChangesFilters(true);
                }}
              />
              <Button
                type="icon"
                icon="delete"
                style={{ color: 'white' }}
                className="header-icon"
                aria-label={messages['dashboardPanel_user_gadget_delete_title']}
                tooltip={messages['dashboardPanel_user_gadget_delete_title']}
                onClick={() => {
                  setOpenConfirmationDelete({
                    active: true,
                    item
                  })
                }}
              />
            </>
          }
        </Grid>
        
      </Grid>
      <CardContent className="card-content-gadget-dashboard"  >
        <Gadgets item={item} update={update} changesFilters={changesFilters} setChangesFilters={setChangesFilters} />
      </CardContent>
      <GlobalAlert
        open={openConfirmationDelete?.active === true}
        title={`${messages['dashboardPanel_deleteTitle']}`}
        contentText={`${messages['dashboardPanel_delete_title']}`}
        confirmText={messages['dashboardPanel_deleteTitle']}
        type="success"
        cancelText={messages['dashboardPanel_cancelMessage']}
        onClose={() => {
          setOpenConfirmationDelete({})
        }}
        onClick={() => {
          dispatch(deleteGadgetDashboardPanel(openConfirmationDelete?.item?.id));
          deleteGadget(openConfirmationDelete?.item);
        }}
      />
    </div>

  );
}

export default UserGadget;
